import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import fire from './firebase';
import rd3 from 'rd3';
const LineChart = rd3.LineChart;

class App extends Component {
  constructor(props){
    super(props);
    this.state = {humidity:[], temperature:[], current:[]};
  }
  componentDidMount(){
    //pl.Plotly.newPlot('plot');
  }
  componentWillMount(){
    let mRefHumidity = fire.database().ref('/telemetry/iotdata/humidity').limitToLast(20);
    mRefHumidity.on('child_added', snapshot => {
      let messageH = {
        x: new Date(snapshot.val().createdAt),
        y: snapshot.val().value
      };
      //arr.splice(-2, 2);
      this.setState({ 
        humidity:[messageH].concat((this.state.humidity.filter((a,i) => i > this.state.humidity.length - 20)))
      });
    });
    let mRefTemperature = fire.database().ref('/telemetry/iotdata/temperature').limitToLast(20);
    mRefTemperature.on('child_added', snapshot => {
      let messageT = {
        x: new Date(snapshot.val().createdAt),
        y: snapshot.val().value
      };
      //arr.splice(-2, 2);
      this.setState({ 
        temperature:[messageT].concat((this.state.temperature.filter((a,i) => i > this.state.temperature.length - 20)))
      });
    });
    let mRefCurrent = fire.database().ref('/telemetry/iotdata/current').limitToLast(20);
    mRefCurrent.on('child_added', snapshot => {
      let messageC = {
        x: new Date(snapshot.val().createdAt),
        y: snapshot.val().value
      };
      //arr.splice(-2, 2);
      this.setState({ 
        current:[messageC].concat((this.state.current.filter((a,i) => i > this.state.current.length - 20)))
      });
    });
  }
  render() {
    let { width, height, margin, xScale, yScale, xAxis, ...props } = this.props;
    let vbo = { 
      x : 0, 
      y: 0,
      width: 600,
      height: 400
    };
    let humidityLineData = [
      {
        name: "Humedad dispositivo 1",
        values: [{x: 0, y: 30 }],
        strokeWidth: 3,
        strokeDashArray: "5,5"
      }
    ]; 
    if(this.state.humidity.length > 0){
      humidityLineData = [
        {
          name: "Humedad suelo dispositivo 1",
          values: this.state.humidity,
          strokeWidth: 2,
          strokeDashArray: "5,5"
        }
      ];
    }
    let temperatureLineData = [
      {
        name: "Temperatura dispositivo 1",
        values: [{x: 0, y: 30 }],
        strokeWidth: 3,
        strokeDashArray: "5,5"
      }
    ]; 
    if(this.state.temperature.length > 0){
      temperatureLineData = [
        {
          name: "Temperatura dispositivo 1",
          values: this.state.temperature,
          strokeWidth: 2,
          strokeDashArray: "5,5"
        }
      ];
    }
    let currentLineData = [
      {
        name: "Humedad dispositivo 1",
        values: [{x: 0, y: 30 }],
        strokeWidth: 3,
        strokeDashArray: "5,5"
      }
    ]; 
    if(this.state.current.length > 0){
      currentLineData = [
        {
          name: "Humedad aire dispositivo 1",
          values: this.state.current,
          strokeWidth: 2,
          strokeDashArray: "5,5"
        }
      ];
    }
    xScale && xScale.range([0, width - (margin.left + margin.right)]);
    yScale && yScale.range([height - (margin.top + margin.bottom), 0]);
    return (
      <div className="App">
        <div className="App-header">
          <h2>Mecatrónica del Sur (SouthTronics)</h2>
        </div>
        <div id="plot">
        
        <LineChart
          legend={true}
          data={humidityLineData}
          width='100%'
          height={400}
          viewBoxObject={vbo}
          title="Humedad del suelo en dispositivos"
          yAxisLabel="Humedad %"
          xAxisLabel="Tiempo"
          xScale={xScale}
          yScale={yScale}
          gridHorizontal={true}

        />
        <LineChart
          legend={true}
          data={temperatureLineData}
          width='100%'
          height={400}
          viewBoxObject={vbo}
          title="Temperatura en dispositivos"
          yAxisLabel="Temperatura °C"
          xAxisLabel="Tiempo"
          xScale={xScale}
          yScale={yScale}
          gridHorizontal={true}

        />
        <LineChart
          legend={true}
          data={currentLineData}
          width='100%'
          height={400}
          viewBoxObject={vbo}
          title="Humedad del aire en dispositivos"
          yAxisLabel="Humedad %"
          xAxisLabel="Tiempo"
          xScale={xScale}
          yScale={yScale}
          gridHorizontal={true}

        />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js